module.exports = __webpack_public_path__ + "static/media/meiben01.99f4a5b8.jpg";